import { combineReducers } from 'redux';
import addPaymentContext from './addPaymentContext';
import addPaymentInit from './addPaymentInit';
import addPaymentMethod from './addPaymentMethod';
import addPayPal from './addPayPalAccount';
import paymentsError from './paymentsError';
import verificationContext from './verificationContext';

export default combineReducers({
  addPaymentContext,
  addPaymentInit,
  addPaymentMethod,
  addPayPal,
  paymentsError,
  verificationContext,
});
